import { RefundsInfoContainer } from './RefundsInfo.styles';
import { PBody } from 'shared/components/Fonts';
import { formatCurrency } from 'shared/utils';
import { RefundData } from 'core/cuenta/models/RefundData';
import { Card } from 'shared/components';
import { TextPlaceholder } from 'shared/placeholders';
import { AppIcon } from 'shared/icons/AppIcon';

export const RefundsInfo = ({ refundData }: { refundData: RefundData }) => {
  return (
    <RefundsInfoContainer>
      <div className="column card-item">
        <Card>
          <Card.Title>Cuenta Origen</Card.Title>
          <Card.Body $spacing $padding>
            {refundData ? (
              <>
                <PBody $bold>Denominación: {refundData?.denominacionCuentaOrigen}</PBody>
                <PBody $bold>Número: {refundData?.numeroCuentaOrigen}</PBody>
                <PBody>
                  Saldo disponible: {formatCurrency(refundData?.saldoDisponible)}
                </PBody>
              </>
            ) : (
              <>
                <TextPlaceholder />
                <TextPlaceholder />
                <TextPlaceholder />
              </>
            )}
          </Card.Body>
        </Card>
      </div>
      <div className="column icon">
        <AppIcon className="small" name="ChevronDownIcon" />
        <AppIcon className="big" name="ChevronRightIcon" />
      </div>
      <div className="column card-item">
        <Card>
          <Card.Title>Cuenta Destino</Card.Title>
          <Card.Body $spacing $padding>
            {refundData ? (
              <>
                <PBody $bold>Denominación: {refundData?.denominacionCuentaDestino}</PBody>
                <PBody $bold>Número: {refundData?.numeroCuentaDestino}</PBody>
                <PBody>Centro costo: {refundData?.denominacionCentroCostoDestino}</PBody>
              </>
            ) : (
              <>
                <TextPlaceholder />
                <TextPlaceholder />
                <TextPlaceholder />
              </>
            )}
          </Card.Body>
        </Card>
      </div>
    </RefundsInfoContainer>
  );
};
